import { useEffect, useRef, useState } from "react"

import { Input } from "@productlane/ui"
import { mutators } from "@productlane/zero/mutators"

import { useRole } from "@/lib/useRole"
import { mutateOk, useZero } from "@/lib/zero"

export const CompanyNameInput = ({
	companyId,
	name,
}: {
	companyId: string
	name: string
}) => {
	const zero = useZero()
	const { role } = useRole()
	const [value, setValue] = useState(name)
	// Navigating between customers reuses this input, so an unsynced value would be saved onto the next company.
	const editedIdRef = useRef<string | null>(null)

	useEffect(() => {
		if (editedIdRef.current !== companyId) setValue(name)
	}, [companyId, name])

	const save = async (newName: string) => {
		if (role === "VIEWER" || newName === name) return
		await mutateOk(
			zero.mutate(mutators.companies.update({ id: companyId, name: newName })),
		)
	}

	return (
		<Input
			name="company-name"
			data-testid="company-name"
			variant="borderless"
			textSize="xl"
			inputClassName="truncate font-semibold text-primary px-0 h-auto"
			className="pl-2"
			value={value}
			placeholder="Company name"
			readOnly={role === "VIEWER"}
			onChange={(e) => {
				setValue(e.target.value)
			}}
			onFocus={() => {
				editedIdRef.current = companyId
			}}
			onBlur={async (e) => {
				const editedId = editedIdRef.current
				editedIdRef.current = null
				if (editedId !== companyId) {
					setValue(name)
					return
				}
				await save(e.target.value)
			}}
			onKeyDown={(e) => {
				if (e.key === "Enter") {
					e.preventDefault()
					e.currentTarget.blur()
				}
			}}
		/>
	)
}
